export { HomePage as default } from '@/modules/HomePage';
export { getServerSideProps } from '@/modules/HomePage/HomePageServer';
